export default "__VITE_ASSET__6901a099__"